export default __webpack_public_path__ + "static/P_SearchThumb_Sighthound-75d1273c78f5ad9adc6f13df60a20ca8.webp";